import Vue from "vue";
import ElementUI from "element-ui";
import "normalize.css/normalize.css";
import "./styles/reset.scss";
import "./styles/common.scss";
import App from "./App.vue";
import router from "./router";
import "@/plugin/axios";
import store from "./store";
import config from "@/config/index.js";
import MiniVrx from "mini-vrx";
import QCLog from "qclog";
import QCStorage from "qc-storage";
import VueClipboard from "vue-clipboard2";
Vue.config.productionTip = false;
import "./styles/element-style.scss";
import VueTinymce from "@packy-tang/vue-tinymce";
import loader from "./utils/libs/request-rx";
import hevueImgPreview from "hevue-img-preview";
import {
  singleMessage
} from '@/utils/resetMessage';
import * as echarts from 'echarts';
// 图片预览
Vue.use(hevueImgPreview, {
  keyboard: true,
  clickMaskCLose: true,
});
Vue.use(VueClipboard);
Vue.use(VueTinymce);
Vue.use(ElementUI);
Vue.use(config);
Vue.use(MiniVrx); //subscription
Vue.prototype.$bus = new Vue(); //evnets center
Vue.prototype.$storage = QCStorage.getInstance(); //local storage
Vue.prototype.$loader = loader;
import Viser from "viser-vue";
Vue.use(Viser);
Vue.prototype.$singleMessage = singleMessage;
Vue.prototype.$echarts = echarts;

//debug tools
if (process.env.NODE_ENV === "development") {
  //new VConsole();
  Vue.prototype.$elog = QCLog.getInstance("development");
} else {
  Vue.prototype.$elog = QCLog.getInstance("prod");
}

import { VueJsonp } from "vue-jsonp";
import { load } from "js-yaml";
Vue.use(VueJsonp);

import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '36362ccd04573d97c4ff42b17067461f',
  securityJsCode: 'bda3372bdb7d7d388f2bc2fab69093fc',
  plugins: ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Autocomplete'],
  version: '2.0',
  AMapUI: {
    version: '1.1',
    plugins: ['misc/PositionPicker', 'misc/PoiPicker']
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
